<div
  mat-dialog-content
  class="cej-v2-contact-modal"
  [class.dialog-form--saving]="saving$ | async"
  [class.dialog-form--saved]="saved$ | async"
>
  <ng-container *ngIf="(saving$ | async) === false && (saved$ | async) === false; else formSubmitted">
    <ng-container *ngIf="(saving$ | async) === false && (saved$ | async) === false">
      <button
        mat-icon-button
        type="button"
        aria-label="Fermer le formulaire"
        class="btn-clean btn-close cej-v2-contact-modal__close-button"
        (click)="closeDialog()"
      >
        <mat-icon svgIcon="cross" role="presentation"></mat-icon>
      </button>
    </ng-container>
    <header role="banner" class="cej-v2-contact-modal__header">
      <h3 role="heading" class="cej-v2-contact-modal__header__title">
        J&apos;ai des questions sur le Contrat d&apos;Engagement Jeune et souhaite être rappelé
      </h3>
    </header>
    <form
      [formGroup]="cejContactForm"
      class="cej-v2-contact-modal__form"
      (ngSubmit)="cejContactForm.valid && doSubmit()"
    >
      <!-- lecture du prénom -->
      <mat-form-field class="cej-v2-contact-modal__form--firstName">
        <mat-label>Prénom</mat-label>
        <input type="text" matInput formControlName="firstName" />
        <mat-error *ngIf="firstName?.errors as errors">
          <ng-container *ngIf="errors?.required">Le prénom est requis</ng-container>
        </mat-error>
      </mat-form-field>
      <!-- lecture du nom -->
      <mat-form-field class="cej-v2-contact-modal__form--lastName">
        <mat-label>Nom</mat-label>
        <input type="text" matInput formControlName="lastName" />
        <mat-error *ngIf="lastName?.errors as errors">
          <ng-container *ngIf="errors.required">Le nom est requis</ng-container>
        </mat-error>
      </mat-form-field>
      <!-- lecture de l'adresse e-mail -->
      <mat-form-field class="cej-v2-contact-modal__form--email">
        <mat-label>Adresse email</mat-label>
        <input type="email" matInput formControlName="email" />
        <mat-error *ngIf="email?.errors as errors">
          <ng-container *ngIf="errors.required">L&apos;adresse email est requise</ng-container>
          <ng-container *ngIf="errors.email">Ce format d&apos;adresse email est invalide</ng-container>
        </mat-error>
      </mat-form-field>
      <!-- lecture du numéro de téléphone -->
      <mat-form-field class="cej-v2-contact-modal__form--phone">
        <mat-label>Téléphone</mat-label>
        <input type="phone" matInput formControlName="phoneNumber" />
        <mat-error *ngIf="phone?.errors as errors">
          <ng-container *ngIf="errors.phone"> Le numéro de téléphone est incorrect </ng-container>
          <ng-container *ngIf="errors.required">Le numéro de téléphone est requis</ng-container>
        </mat-error>
      </mat-form-field>
      <!-- lecture de l'age -->
      <mat-form-field class="cej-v2-contact-modal__form--age">
        <mat-label>Âge</mat-label>
        <mat-select
          formControlName="age"
          #ageSelect="matSelect"
          aria-label="Contact mission locale, liste déroulante réduite pour sélectionner l'âge"
        >
          <mat-option *ngFor="let age of ages; trackBy: trackByAge" [value]="age">{{ age }} ans</mat-option>
        </mat-select>
        <mat-error *ngIf="age?.errors?.required || age?.errors?.whitespace">L&apos;âge est requis</mat-error>
      </mat-form-field>
      <!-- lecture du code postal -->
      <app-zipcode-input-pole-emploi
        formControlName="city"
        class="cej-v2-contact-modal__form--zipcode"
        [fieldConfig]="zipCodeFieldConfig"
      ></app-zipcode-input-pole-emploi>

      <app-checkbox-input
        name="receive-info-checkbox"
        class="cej-v2-contact-modal__form--receive-infos"
        [required]="false"
        formControlName="acceptToReceiveInfos"
        >J&apos;accepte de recevoir des informations de "1 jeune,&nbsp;1 solution"
      </app-checkbox-input>
      <div class="cej-v2-contact-modal__form__commands">
        <button type="submit" class="btn btn-clean btn-submit" [attr.aria-label]="submitButtonLabel">
          {{ submitButtonLabel }}
        </button>
      </div>
    </form>
    <app-form-rgpd-info [info]="rgpdInfo"></app-form-rgpd-info>
  </ng-container>
</div>

<ng-template #formSubmitted>
  <app-checkmark-loader class="loader" [loading]="saving$ | async">Envoi…</app-checkmark-loader>

  <h4 role="heading" class="title">
    <ng-container *ngIf="saving$ | async">Envoi en cours</ng-container>
    <ng-container *ngIf="saved$ | async">Votre demande a bien été transmise&nbsp;!</ng-container>
  </h4>

  <ng-container *ngIf="saved$ | async">
    <button type="button" class="btn-clean validate" (click)="closeDialog()">Fermer</button>
  </ng-container>
</ng-template>
